import axios from 'axios';

interface ApiErrorPayload {
  statusCode?: number;
  message?: string | string[];
  error?: string;
}

export function extractErrorMessage(
  error: unknown,
  fallback: string,
  formatMessage?: (value: string) => string,
) {
  const getMessage = (value: string) =>
    formatMessage ? formatMessage(value) : value;

  if (axios.isAxiosError<ApiErrorPayload>(error)) {
    const message = error.response?.data?.message;

    if (Array.isArray(message) && message.length > 0) {
      return getMessage(message[0]);
    }

    if (typeof message === 'string') {
      return getMessage(message);
    }
  }

  return getMessage(fallback);
}
